// this should always equal schemaVersion, below
export const currentSchemaVersion = "9";
